import { render, staticRenderFns } from "./AnswersTextResultList.vue?vue&type=template&id=c8f63d92&"
import script from "./AnswersTextResultList.vue?vue&type=script&lang=js&"
export * from "./AnswersTextResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports